'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _campaignSelectModal = require('./campaignSelectModal.html');

var _campaignSelectModal2 = _interopRequireDefault(_campaignSelectModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactDetailController = function () {
    function ContactDetailController($scope, $state, $stateParams, ApiInvestors, ApiContacts, ApiCampaigns, $ionicLoading, $ionicModal, ApiTasks, ApiTeam, ApiUser, $q, MessageBox, $ionicPopup, $filter) {
        _classCallCheck(this, ContactDetailController);

        this.ApiInvestors = ApiInvestors;
        this.ApiContacts = ApiContacts;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiTasks = ApiTasks;
        this.ApiTeam = ApiTeam;
        this.ApiUser = ApiUser;
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.MessageBox = MessageBox;
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.contactCampaignmodal = $ionicModal.fromTemplate(_campaignSelectModal2.default, { scope: $scope });

        // Prerequisites
        this.investorId = $stateParams.investorId;
        this.investor = {};
        this.isCustomerInvestor = $stateParams.isCustomerInvestor;
        this.advindaCount = $stateParams.advindaCount;
        this.customCount = $stateParams.customCount;
        this.translationVisible = false;
        this.addInfoVisible = false;
        this.campaigns = [];
    }

    _createClass(ContactDetailController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.showLoading();

            // Load contact from database

            this.getInvestor();
            this.getTeams();

            if (this.isCustomerInvestor) {
                this.taskParameters = {
                    taskRelations: ['INVESTOR'],
                    customerInvestorIds: [this.investorId]
                };
            } else {
                this.taskParameters = {
                    taskRelations: ['INVESTOR'],
                    investorIds: [this.investorId]
                };
            }

            this.currentStateName = this.$state.current.name;

            this.ApiUser.getUser().then(function (res) {
                if (typeof res != 'undefined') {
                    _this.userGroupId = res.groupId;
                }
            });
            this.assignedContacts = new Set();
        }
    }, {
        key: 'getInvestor',
        value: function getInvestor() {
            var _this2 = this;

            this.ApiInvestors.getInvestor(this.investorId, {
                isCustomerAccount: this.isCustomerInvestor
            }).then(function (res) {
                _this2.hideLoading();
                _this2.$ionicLoading.hide();
                if (typeof res != 'undefined') {
                    _this2.investor = res;
                    _this2.description = _this2.getInvestorDescriptionText();
                    _this2.investor.investor.additionalInformation = !_this2.isCustomerInvestor && _this2.investor.advindaAccountAdditionalInfo ? _this2.investor.advindaAccountAdditionalInfo.additionalInfo : _this2.investor.investor.additionalInformation;

                    _this2.investorContainsInfo = _this2.investor.investor.investorPhone || _this2.investor.investor.additionalPhone || _this2.investor.investor.mobile || _this2.investor.investor.fax || _this2.investor.investor.email || _this2.investor.investor.additionalEmail || _this2.investor.investor.website || _this2.investor.investor.billingStreet || _this2.investor.investor.postalCode || _this2.investor.investor.billingCity || _this2.investor.investor.billingState || _this2.investor.investor.billingCountry;
                    _this2.isAddressVisible = _this2.investor.investor.billingStreet || _this2.investor.investor.postalCode || _this2.investor.investor.billingCity || _this2.investor.investor.billingState || _this2.investor.investor.billingCountry;
                    _this2.isAdditionalAddressVisible = _this2.investor.investor.additionalAddress || _this2.investor.investor.additionalZip || _this2.investor.investor.additionalCity || _this2.investor.investor.additionalState || _this2.investor.investor.additionalCountry;
                    _this2.isAddressTranslationVisible = _this2.investor.investor.countryTranslated || _this2.investor.investor.stateTranslated || _this2.investor.investor.cityTranslated || _this2.investor.investor.zipTranslated || _this2.investor.investor.addressTranslated;
                }
            });
        }
    }, {
        key: 'promptDeleteInvestor',
        value: function promptDeleteInvestor($event) {
            var _this3 = this;

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')('DELETE_INVESTOR'),
                template: this.$filter('translate')('DELETE_INVESTOR_PROMPT')
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this3.deleteInvestor(_this3.investor);
                }
            });
        }
    }, {
        key: 'deleteInvestor',
        value: function deleteInvestor(investor) {
            var _this4 = this;

            this.showLoading();
            this.ApiInvestors.deleteInvestor(investor.investor.investorId).then(function (res) {
                _this4.hideLoading();
                if (res === null) {
                    _this4.$state.go('investors', { defaultTab: 'TEAM' }, { reload: true });
                    // The message is commented out based on task AIC-1805
                    // this.MessageBox.showSuccessMessage('INVESTOR', 'DELETE');
                }
            });
        }
    }, {
        key: 'deleteContact',
        value: function deleteContact(contact) {
            var _this5 = this;

            this.ApiContacts.deleteContact(contact.id).then(function (res) {
                if (res) {
                    _this5.investor.contacts.splice(_this5.investor.contacts.indexOf(contact), 1);
                }
            });
        }
    }, {
        key: 'retrieveContactDetailUrl',
        value: function retrieveContactDetailUrl(contact) {
            if (contact.customer === null) {
                return this.$state.href('contactsDetail', {
                    contactId: contact.id,
                    isCustomerContact: false
                });
            } else {
                return this.$state.href('customerContactsDetail', {
                    contactId: contact.id,
                    isCustomerContact: true
                });
            }
        }
    }, {
        key: 'retrieveContactDetailUisref',
        value: function retrieveContactDetailUisref(customer) {
            if (customer === null) {
                return 'contactsDetail({contactId: contact.id, isCustomerContact: false})';
            } else {
                return 'customerContactsDetail({contactId: contact.id, isCustomerContact: true})';
            }
        }
    }, {
        key: 'getInvestorDescriptionText',
        value: function getInvestorDescriptionText() {
            if (!this.investor || !this.investor.investor) return '';
            var text = '' + (this.investor.investor.subType || '');
            text = text.trim();
            if (text === '') return this.investor.investor.billingCountry || '';
            if (text != '' && this.investor.investor.billingCountry != '') return text + ' | ' + this.investor.investor.billingCountry;
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.$ionicLoading.hide();
        }
    }, {
        key: 'onCommentEntered',
        value: function onCommentEntered(comment) {
            var _this6 = this;

            this.showLoading();
            if (this.investor.advindaAccountAdditionalInfo && this.investor.advindaAccountAdditionalInfo.id) {
                this.additionalInfo = {
                    additionalInfo: comment,
                    accountId: this.investor.advindaAccountAdditionalInfo.accountId,
                    groupId: this.investor.advindaAccountAdditionalInfo.groupId,
                    id: this.investor.advindaAccountAdditionalInfo.id
                };

                this.ApiInvestors.putAdditionalInfo(this.additionalInfo).then(function (res) {
                    _this6.getInvestor();
                }, function () {
                    this.hideLoading();
                });
            } else {
                this.additionalInfo = {
                    additionalInfo: comment,
                    accountId: this.investorId,
                    groupId: this.userGroupId
                };
                this.ApiInvestors.postAdditionalInfo(this.additionalInfo).then(function (res) {
                    _this6.getInvestor();
                }, function () {
                    this.hideLoading();
                });
            }
        }
    }, {
        key: 'onCommentEnteredAllocationInfo',
        value: function onCommentEnteredAllocationInfo(comment) {
            var _this7 = this;

            this.showLoading();
            if (this.investor.assetAllocationAdditionalInfoDto && this.investor.assetAllocationAdditionalInfoDto.id) {
                this.allocationInfo = {
                    additionalInfo: comment,
                    accountId: this.investor.assetAllocationAdditionalInfoDto.accountId,
                    groupId: this.investor.assetAllocationAdditionalInfoDto.groupId,
                    id: this.investor.assetAllocationAdditionalInfoDto.id
                };

                this.ApiInvestors.putAllocationInfo(this.allocationInfo).then(function (res) {
                    _this7.getInvestor();
                }, function () {
                    this.hideLoading();
                });
            } else {
                this.allocationInfo = {
                    additionalInfo: comment,
                    accountId: this.investorId,
                    groupId: this.userGroupId
                };
                this.ApiInvestors.postAllocationInfo(this.allocationInfo).then(function (res) {
                    _this7.getInvestor();
                }, function () {
                    this.hideLoading();
                });
            }
        }
    }, {
        key: 'getTeams',
        value: function getTeams() {
            var _this8 = this;

            this.ApiTeam.getTeams().then(function (res) {
                if (typeof res != 'undefined') {
                    if (res) {
                        _this8.translationVisible = res.translationRequired;
                    }
                }
            });
        }
    }, {
        key: 'addToCampaign',
        value: function addToCampaign() {
            var _this9 = this;

            this.ApiCampaigns.getAllChildCampaigns().then(function (campaigns) {
                _this9.campaigns = campaigns || [];
            });
            this.contactCampaignmodal.show();
        }
    }, {
        key: 'addToContactList',
        value: function addToContactList(contact) {
            if (contact.checked) {
                this.assignedContacts.add(contact.id);
            } else {
                this.assignedContacts.delete(contact.id);
            }
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.contactCampaignmodal.hide();
        }
    }, {
        key: 'cancelModal',
        value: function cancelModal() {
            this.closeModal();
        }
    }, {
        key: 'cancelContactSelection',
        value: function cancelContactSelection() {
            this.campaignSelected = false;
            this.assignedContacts.clear();
            this.closeModal();
        }
    }, {
        key: 'cancelCampaignSelection',
        value: function cancelCampaignSelection() {
            this.investor.contacts.map(function (c) {
                return c.checked = false;
            });
            this.assignedContacts.clear();
            this.showChangeCampaign = false;
            this.showCheckboxes = false;
            this.campaignSelected = false;
        }
    }, {
        key: 'selectCampaign',
        value: function selectCampaign(campaign) {
            this.campaignSelected = true;
            this.selectedCampaignId = campaign.campaignId;
            this.selectedCampaignTitle = campaign.campaignTitle;
            this.closeModal();
        }
    }, {
        key: 'addContactstoCampaign',
        value: function addContactstoCampaign() {
            var _this10 = this;

            var assignPromises = [];
            if (this.assignedContacts.size > 0 && !this.isCustomerInvestor) {
                assignPromises.push(this.ApiCampaigns.putCampaignContacts(this.selectedCampaignId, this.assignedContacts));
            }
            if (this.assignedContacts.size > 0 && this.isCustomerInvestor) {
                assignPromises.push(this.ApiCampaigns.putCampaignCustomerContacts(this.selectedCampaignId, this.assignedContacts));
            }

            Promise.all(assignPromises).then(function () {
                _this10.cancelCampaignSelection();
                _this10.MessageBox.showSuccessMessage('CONTACT', 'ASSIGN');

                /*
                this.$state.go(
                    'campaignDetail',
                    { campaignId: this.selectedCampaignId },
                    { reload: true }
                 );
                 */
            });
        }
    }]);

    return ContactDetailController;
}();

exports.default = ContactDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/investors/investorDetail.controller.js
 **/